<h1 mat-dialog-title [innerHTML]="data.title"></h1>
<div mat-dialog-content [innerHTML]="data.content"></div>
<div class="wrapper">
  <mat-spinner class="inner"></mat-spinner>
</div>
<div style="display: flex; align-items: flex-end; justify-content: flex-end">
  <button mat-button color="warn" (click)="cancel()">취소</button>
</div>
